import React from "react"
import { StaticImage } from "gatsby-plugin-image"
import loadable from "@loadable/component"
import "./planes.scss"

const CarouselCards = loadable(() => import("../../../CarouselCards/index.js"))

export const PlanesSection = () => {
  return (
    <>
      <section className="servicios-planes-container">
        <div
          className="servicios-planes-info-container"
          data-sal="slide-up"
          data-sal-delay="200"
          data-sal-easing="ease"
        >
          <div className="servicios-planes-info-text">
            <h2>Servicios</h2>
            <p>
              Disponemos de un amplio
              <span> catálogo de planes de soporte y de mantenimiento </span>
              que se adaptan a las necesidades de cada cliente y así cumplir con
              nuestro principal objetivo: satisfacer los requerimientos de
              nuestro cliente, aportando el máximo valor a sus servicios y/o
              instalaciones con una justa relación calidad-coste.
            </p>
          </div>
        </div>
        <CarouselCards />
        <div
          className="servicios-planes-card-preventivo-container servicios-cards servicios-item"
          data-sal="slide-up"
          data-sal-delay="200"
          data-sal-easing="ease"
        >
          <div className="servicios-planes-card-preventivo-text servicios-cards-body">
            <StaticImage
              src="../../../../images/servicios/planes/mantenimiento-preventivo.svg"
              alt="icon preventivo"
            />
            <h3>
              Mantenimiento
              <br /> preventivo
            </h3>
            <p>
              Supervisión remota, tareas preventivas y visitas programadas de
              mantenimiento, con el objetivo de garantizar el correcto
              funcionamiento de equipos y sistemas, minimizando la aparición de
              incidencias.
            </p>
          </div>
        </div>
        <div
          className="servicios-planes-card-correctivo-container servicios-cards servicios-item"
          data-sal="slide-up"
          data-sal-delay="200"
          data-sal-easing="ease"
        >
          <div className="servicios-planes-card-correctivo-text servicios-cards-body">
            <StaticImage
              src="../../../../images/servicios/planes/mantenimiento-correctivo.svg"
              alt="icon correctivo"
            />
            <h3>
              Mantenimiento
              <br /> correctivo
            </h3>
            <p>Tiene como finalidad la reparación no sujeta a programa.</p>
            <ul>
              <li className="text-blue">
                • Asistencia in situ a petición del cliente{" "}
              </li>
              <li>• Soporte remoto</li>
              <li className="text-blue">• Tiempo de respuesta preferencial</li>
              <li>• Plan de horas</li>
            </ul>
          </div>
        </div>
        <div
          className="servicios-planes-card-helpdesk-container servicios-cards servicios-item"
          data-sal="slide-up"
          data-sal-delay="200"
          data-sal-easing="ease"
        >
          <div className="servicios-planes-card-helpdesk-text servicios-cards-body">
            <StaticImage
              src="../../../../images/servicios/planes/help-desk.svg"
              alt="icon helpdesk"
            />
            <h3>Help desk</h3>
            <p>
              Soporte online para la solución inmediata de dudas o problemas de
              operativa y funcionamiento.
            </p>
          </div>
        </div>
        <div
          className="servicios-planes-card-gestion-container servicios-cards servicios-item"
          data-sal="slide-up"
          data-sal-delay="200"
          data-sal-easing="ease"
        >
          <div className="servicios-planes-card-gestion-text servicios-cards-body">
            <StaticImage
              src="../../../../images/servicios/planes/gestion-remota.svg"
              alt="icon gestion"
            />
            <h3>Gestión remota</h3>
            <p>
              Soporte online para el apoyo en la operativa de sistemas, así como
              para el mantenimiento y monitorización remota de los equipos
              propiedad del cliente.
            </p>
            <ul>
              <li className="text-blue">• Supervisión de equipos</li>
              <li>• Equipos Audiovisuales</li>
              <li className="text-blue">• VideoConferencia</li>
              <li>• Cartelería</li>
              <li className="text-blue">• Actualización de software</li>
              <li>• Actuaciones correctivas en remoto</li>
            </ul>
          </div>
        </div>
        <div
          className="servicios-planes-card-asesoramiento-container servicios-cards servicios-item"
          data-sal="slide-up"
          data-sal-delay="200"
          data-sal-easing="ease"
        >
          <div className="servicios-planes-card-asesoramiento-text servicios-cards-body">
            <StaticImage
              src="../../../../images/servicios/planes/asesoramiento.svg"
              alt="icon asesoramiento"
            />
            <h3>Asesoramiento</h3>
            <p>
              Asesoramiento a nuestros clientes en la actualización de equipos y
              sistemas. Incluye asesoramiento técnico especializado e
              información puntual sobre las evoluciones tecnológicas de los
              equipos y sistemas instalados, así como el seguimiento para
              renovación de las garantías del fabricante.
            </p>
          </div>
        </div>
      </section>
    </>
  )
}
